// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-master-disclaimer-dialog h1 {
  margin: 24px !important;
  font: 500 20px/32px Roboto, "Helvetica Neue", sans-serif;
  letter-spacing: normal;
  font-weight: 500 !important;
}
app-master-disclaimer-dialog p {
  font: 14px/1.2 "Source Sans Pro", sans-serif;
  color: rgba(0, 0, 0, 0.87);
}
app-master-disclaimer-dialog .mat-dialog-content {
  height: 350px;
  min-height: 350px;
}
app-master-disclaimer-dialog .mat-dialog-container {
  padding: 0;
}
app-master-disclaimer-dialog .mat-dialog-container .spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
}
app-master-disclaimer-dialog .mat-dialog-container .mat-toolbar {
  flex: 1 0 auto;
  min-height: initial;
}
app-master-disclaimer-dialog .mat-dialog-container .toolbar-bottom {
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/dialogs/master-disclaimer-dialog/master-disclaimer-dialog.component.less"],"names":[],"mappings":"AACA;EAEI,uBAAA;EACA,wDAAA;EACA,sBAAA;EACA,2BAAA;AADJ;AAJA;EASI,4CAAA;EACA,0BAAA;AAFJ;AARA;EAcI,aAAA;EACA,iBAAA;AAHJ;AAZA;EA2BI,UAAA;AAZJ;AAfA;EAqBM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAHN;AArBA;EA8BM,cAAA;EACA,mBAAA;AANN;AAzBA;EAmCM,YAAA;AAPN","sourcesContent":["// @import (reference) '../../../../../styles.less';\napp-master-disclaimer-dialog {\n  h1 {\n    margin: 24px !important;\n    font: 500 20px/32px Roboto, \"Helvetica Neue\", sans-serif;\n    letter-spacing: normal;\n    font-weight: 500 !important;\n  }\n\n  p {\n    font: 14px/1.2 \"Source Sans Pro\", sans-serif; \n    color: rgba(0,0,0,.87);\n  }\n\n  .mat-dialog-content {\n    height: 350px;\n    min-height: 350px;\n  }\n\n  .mat-dialog-container {\n\n    .spinner-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding-top: 100px;\n    }\n\n    padding: 0;\n\n    .mat-toolbar {\n      flex: 1 0 auto;\n      min-height: initial;\n    }\n\n    .toolbar-bottom {\n      height: auto;\n    }\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
